import {
  EnvSection,
  EnvTopic,
} from '@/domain/impact-env/entities/question.entity';

/**
 * Retireve topics in combobox on top of form side panel
 */
export function prepareEnvTopicsDisplayed(
  envQuizLayout: Record<EnvTopic, { sections: Array<EnvSection> }>,
): EnvTopic[] {
  return Object.keys(envQuizLayout)
    .filter((x) => envQuizLayout[x as EnvTopic].sections.length > 0)
    .filter((x) => x !== 'GLOBAL_CO2')
    .map((x) => x as EnvTopic);
}
